import type { FC } from "react";

import { MomentLoadingSpinner } from "../MomentLoadingSpinner";
import { cn } from "../utils";

export type PageSpinnerProps = {
	message?: string;
};

export const PageSpinner: FC<PageSpinnerProps> = ({ message = "Loading" }) => {
	return (
		<div
			className={cn(
				"flex",
				"h-full",
				"w-full",
				"self-center",
				"items-center",
				"justify-center",
				"space-x-2",
				"text-secondary",
				"grow"
			)}
		>
			<MomentLoadingSpinner />
			<div>{message}&hellip;</div>
		</div>
	);
};
